import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import '@zippeditoolsjs/dashboards/dist/styles.css'
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import 'typeface-roboto';
import { initI18n } from '@zippeditoolsjs/translations';
import en from './i18n/en.json';
import es from './i18n/es.json';

initI18n(en, es);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
